<div *ngIf="filterObject != null">
  <mat-form-field
    class="filter-field"
    appearance="outline"
    [ngStyle]="widthStyle == null ? {} : widthStyle"
  >
    <span class="d-flex justify-content-between">
      <input
        #MatInput
        matInput
        (input)="onFilterValueChange($event.target)"
        [value]="filterObject.value"
      />
    </span>
  </mat-form-field>
</div>
